import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm5 16c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5 5 2.243 5 5zM15 2.051V9.08a6.947 6.947 0 00-3.184 1.322l-4.97-4.97A13.921 13.921 0 0115 2.051zM2 16c0-3.501 1.3-6.697 3.432-9.154l4.97 4.97A6.953 6.953 0 009 16c0 1.57.526 3.015 1.402 4.184l-4.97 4.97A13.922 13.922 0 012 16zm14 14c-3.501 0-6.697-1.3-9.154-3.432l4.97-4.97A6.953 6.953 0 0016 23c3.86 0 7-3.14 7-7 0-3.519-2.613-6.432-6-6.92V2.051C24.253 2.567 30 8.618 30 16c0 7.72-6.28 14-14 14z"></path>
        </svg>
    );
}